import { NotFoundScreen } from '@/screens/public/NotFoundScreen';
import { FC, ReactNode } from 'react';
import { LoaderFullscreen } from '@/components/layout/Loader';
import { useSelector } from 'react-redux';
import { getActiveEnterprise } from '@/slices/enterprises/enterprise.selector';

type EnterpriseLicenseGuardProps = {
  children: ReactNode;
};

export const EnterpriseLicenseGuard: FC<EnterpriseLicenseGuardProps> = ({
  children,
}) => {
  const enterprise = useSelector(getActiveEnterprise);

  if (!enterprise) {
    return <LoaderFullscreen />;
  }

  if (!enterprise.hasLicense) {
    return <NotFoundScreen />;
  }

  return <>{children}</>;
};
